import React, { Component } from "react";
import { callBackendAPI, generateSource } from './../../helpers/common';
import { STATUS_SUCCESS, CALENDAR_MODIFIED_DATE_TIME_FORMAT } from './../../config/global_constants';
import { translate, formatDate } from './../../helpers/intl_helpers';

export default class SmsHistory extends Component {
	constructor(props) {
		super(props);

		this.state = {
			smsList: [],
			expandedRows: {},
			page: 1,
			hasMore: true,
			loading: false
		};

		this.closeModal = this.closeModal.bind(this);
	}

	componentDidMount() {
		this.getSmsHistoryList(1);
		window.document.body.classList.add("modal-open");
		window.document.body.classList.add("overflow-hidden");
	}

	//  API with pagination
	getSmsHistoryList = async (page = 1) => {
		if (this.state.loading || !this.state.hasMore) return;

		this.setState({ loading: true });

		this.source = generateSource();

		try {
			let response = await callBackendAPI([{
				model: 'on_call',
				method: 'sms-history',
				current_page: page
			}], this.source);

			if (
				response?.success &&
				response?.data[0]?.status === STATUS_SUCCESS
			) {
				const newData = response?.data[0]?.result || [];
				const total = response?.data[0]?.recordsTotal || 0;

				this.setState(prev => {
					const updatedList =
						page === 1 ? newData : [...prev.smsList, ...newData];

					return {
						smsList: updatedList,
						page,
						hasMore: updatedList.length < total,
						loading: false
					};
				});
			}
		} catch (err) {
			console.log(err);
			this.setState({ loading: false });
		}
	};

	//  Scroll handler (with debounce)
	handleScroll = (e) => {
		const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;

		const threshold = 100; //  better for mobile + smooth UX

		if (scrollHeight - scrollTop <= clientHeight + threshold) {
			this.getSmsHistoryList(this.state.page + 1);
		}
	};

	//  Expand employee list
	toggleExpand = (index) => {
		this.setState(prev => ({
			expandedRows: {
				...prev.expandedRows,
				[index]: !prev.expandedRows[index]
			}
		}));
	};

	//  Render employee names
	renderEmployeeNames = (employees, index) => {
		const limit = 3;
		const isExpanded = this.state.expandedRows[index];

		if (!employees || employees.length === 0) return "N/A";

		if (isExpanded) {
			return (
				<>
					{employees.map(emp => emp.full_name).join(', ')}
					<span
						className="ms-2 text-primary"
						style={{ cursor: "pointer" }}
						onClick={() => this.toggleExpand(index)}
					>
						Show less
					</span>
				</>
			);
		}

		const visible = employees.slice(0, limit);
		const remaining = employees.length - limit;

		return (
			<>
				{visible.map(emp => emp?.full_name).join(', ')}
				{remaining > 0 && (
					<span
						className="ms-2 text-primary"
						style={{ cursor: "pointer" }}
						onClick={() => this.toggleExpand(index)}
					>
						+{remaining} more
					</span>
				)}
			</>
		);
	};

	closeModal() {
		window.document.body.classList.remove("modal-open");
		window.document.body.classList.remove("overflow-hidden");
		this.props.handelSmsHistory(false);
	}

	render() {
		const { smsList, loading } = this.state;

		return (
			<>
				<div className="modal fade on-call-modal d-block show">
					<div className="modal-dialog modal-dialog-centered modal-lg">
						<div className="modal-content">

							{/* Header */}
							<div className="modal-header">
								<h2 className="modal-title fs-5">
									{translate('on_call.sms_history_report')}
								</h2>
								<button
									type="button"
									className="btn-close"
									onClick={() => this.closeModal()}
								/>
							</div>

							{/* Body with scroll */}
							<div
								className="modal-body"
								style={{ maxHeight: "70vh", overflowY: "auto" }}
								onScroll={this.handleScroll}
							>
								<div className="sms-history-list">

									{smsList && smsList.length > 0 ? (
										smsList.map((val, index) => (
											<div key={val?._id || index} className="sms-card">

												{/* Header */}
												<div className="sms-header">
													<div className="sms-employees">
														<strong>
															{this.renderEmployeeNames(val?.employee_list, index)}
														</strong>
													</div>

													<div className="sms-meta">
														<div>
															{formatDate(val?.scheduled_date, CALENDAR_MODIFIED_DATE_TIME_FORMAT)}
														</div>
														<div>
															{val?.send_by || "N/A"}
														</div>
													</div>
												</div>

												{/* Message */}
												<div className="sms-message">
													{val?.message || "N/A"}
												</div>

											</div>
										))
									) : (
										<div className="text-center mt-3">
											{translate('on_call.no_records_found')}
										</div>
									)}

									{/* Loader */}
									{loading && (
										<div className="text-center mt-2">
											{translate('on_call.loading')}
										</div>
									)}
								</div>
							</div>

						</div>
					</div>
				</div>

				<div className="modal-backdrop fade show"></div>
			</>
		);
	}
}